(() => {
  function enhanceGuide(root) {
    if (!root || root.dataset.nxGuideReady === 'true') return;
    const body = root.querySelector('[data-nx-article-content]');
    const nav = root.querySelector('[data-nx-guide-toc]');
    const list = root.querySelector('[data-nx-guide-toc-list]');
    const mobileNav = root.querySelector('[data-nx-guide-toc-mobile]');
    const mobileList = root.querySelector('[data-nx-guide-toc-mobile-list]');
    if (!body || !nav || !list) return;
    const headings = [...body.querySelectorAll('h2')].filter(heading => heading.textContent.trim());
    root.dataset.nxGuideReady = 'true';
    if (headings.length < 2) return;
    const usedIds = new Set([...document.querySelectorAll('[id]')].map(element => element.id));
    const links = [];
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = `guide-${heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 70) || index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
      if (mobileList) mobileList.append(item.cloneNode(true));
      links.push(link);
    });
    nav.hidden = false;
    if (mobileNav && mobileList) mobileNav.hidden = false;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const visible = entries.find(entry => entry.isIntersecting);
        if (!visible) return;
        links.forEach(link => link.removeAttribute('aria-current'));
        const active = links[headings.indexOf(visible.target)];
        if (active) active.setAttribute('aria-current', 'location');
      }, { rootMargin: '-15% 0px -65% 0px', threshold: 0 });
      headings.forEach(heading => observer.observe(heading));
    }
  }
  function initialize(scope = document) {
    if (scope.matches?.('[data-nx-guide]')) enhanceGuide(scope);
    scope.querySelectorAll('[data-nx-guide]').forEach(enhanceGuide);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
